import { motion } from "framer-motion";
import { waLink } from "@/data/site";
import { HOME } from "@/constants/testIds";

const CTASection = () => {
  return (
    <section
      data-testid={HOME.ctaBookSection}
      className="relative bg-ink text-white py-28 md:py-40 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/8568400/pexels-photo-8568400.jpeg?auto=compress&cs=tinysrgb&w=2000')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/85 to-ink" />
      <div className="container-x relative z-10 text-center max-w-3xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="eyebrow mb-6"
        >
          Klaar om jouw verhaal vast te leggen?
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-serif text-4xl md:text-6xl lg:text-7xl leading-tight"
        >
          Plan je <span className="italic text-gold">fotoshoot.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-6 text-white/70 max-w-xl mx-auto leading-relaxed"
        >
          Vertel me kort wat je in gedachten hebt. Ik neem persoonlijk contact met je op — geen
          formulieren, geen wachttijd.
        </motion.p>
        <motion.a
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="btn-gold mt-10 px-12 py-5 text-sm"
        >
          Boek een shoot
        </motion.a>
      </div>
    </section>
  );
};

export default CTASection;
